module.exports = __webpack_public_path__ + "assets/people/polinaPavlova.bfc3b8912cee6025402fb27a57a59de7.png";